import { useState, useEffect } from "react";
import Slider from "react-slick";
import styled from "styled-components";

const Section = styled.section`
  display: flex;
  align-items: center;
  width: 100%;
  background-color: #191919;
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin: auto;
  max-width: 1290px;
  padding-top: 44px;

  .desktop-title {
    @media (max-width: 860px) {
      display: none;
    }
  }

  .mobile-title {
    display: none;
    padding: 0 24px;
    text-align: center;

    @media (max-width: 861px) {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }

  h2 {
    font-size: 1.5rem;
    font-weight: normal;
    color: #ffffff;
    margin-bottom: 27px;

    @media (max-width: 860px) {
      font-size: 1.375rem;
      margin-top: 0;
      margin-bottom: 15px;
    }
  }

  p {
    font-size: 1.125rem;
    line-height: 25px;
    color: #ffffff;
    padding: 0 24px;
    margin-bottom: 27px;

    @media (max-width: 860px) {
      font-size: 1rem;
      text-align: center;
    }
  }
`;

const TabContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const TabList = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const Tab = styled.button`
  position: relative;
  flex: 1;
  align-items: center;
  justify-content: center;
  min-width: 430px;
  height: 125px;
  background: ${({ $isActive, $primaryColor, $secondaryColor }) =>
    $isActive
      ? `linear-gradient(122deg, ${$primaryColor}, ${$secondaryColor})`
      : "#212121"} !important;
  color: ${({ $isActive }) => ($isActive ? "#ffffff" : "#d4d4d4")};
  font-size: 1.5rem;
  padding: 10px;
  background: none;
  border: none;
  border: 1px solid #000000;
  cursor: pointer;

  @media (max-width: 860px) {
    min-width: 320px;
    height: 80px;
    font-size: 18px;
  }

  @media (max-width: 640px) {
    min-width: 220px;
  }

  @media (max-width: 440px) {
    min-width: 160px;
  }
`;

const TabContent = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  background-color: #151515;
  padding-top: 80px;
  gap: 24px;
  min-height: 560px;

  @media (max-width: 860px) {
    flex-direction: column;
    align-items: center;
    padding-top: 32px;
  }

  .slider-container {
    width: 100%;
    max-width: 557px;
    background-image: url("https://imguol.com.br/p/pp/uol-play/nova-pv/destaques/capas_bg.webp");
    background-position: center;
    background-repeat: no-repeat;

    .slick-slider {
      width: 235px;
      margin: 0 auto;
    }

    .poster {
      width: 235px;
      height: 365px;
      background-color: #202020;
      border-radius: 6px;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 6px;
      }
    }

    .slick-dots li {
      width: initial;
      height: initial;
    }

    .slick-active {
      .slick-custom-dots {
        background-color: #ffce00;
        border: 1px solid #ffce00;
        width: 35px !important;
        overflow: hidden;
      }
    }

    .slick-custom-dots {
      background-color: rgba(255, 255, 255, 0.3);
      width: 10px;
      height: 10px;
      border-radius: 99px;
      transition: all 300ms ease;
    }
  }

  .content {
    width: 100%;
    max-width: 575px;

    .logos {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      column-gap: 4px;
      row-gap: 6px;

      @media (max-width: 860px) {
        padding: 16px;
        padding-bottom: 40px;
      }

      @media (max-width: 640px) {
        grid-template-columns: 1fr 1fr;
        padding: 16px;
        padding-bottom: 40px;
      }

      .logo {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 189px;
        height: 117px;
        background-color: #111111;
        border-radius: 4px;

        @media (max-width: 640px) {
          width: 100%;
        }
      }
    }
  }
`;

const Plus = styled.div`
  position: absolute;
  display: ${({ $isActive }) => ($isActive ? "none" : "block")};
  width: 72px;
  height: 58px;
  bottom: 0;
  right: 0;
  background-color: ${({ $plusColor }) => $plusColor};
  color: #ffffff;
  clip-path: polygon(100% 0, 0% 100%, 100% 100%);

  @media (max-width: 860px) {
    width: 45px;
    height: 36px;
  }

  span:nth-child(1) {
    position: absolute;
    top: 25px;
    left: 48px;
    background-color: #ffffff;
    width: 5px;
    height: 28px;

    @media (max-width: 860px) {
      top: 16px;
      left: 30px;
      width: 3px;
      height: 17px;
    }
  }

  span:nth-child(2) {
    position: absolute;
    top: 25px;
    left: 48px;
    background-color: #ffffff;
    width: 5px;
    height: 28px;
    transform: rotate(90deg);

    @media (max-width: 860px) {
      top: 16px;
      left: 30px;
      width: 3px;
      height: 17px;
    }
  }
`;

const tabs = [
  {
    id: "sports",
    label: "Esportes",
    primaryColor: "#FF2424",
    secondaryColor: "#450000",
    plusColor: "#FE0023",
    content: "Conteúdo da Tab 1",
  },
  {
    id: "liveChannels",
    label: "Canais ao vivo",
    primaryColor: "#891589",
    secondaryColor: "#2E002E",
    plusColor: "#FF17FE",
    content: "Conteúdo da Tab 2",
  },
  {
    id: "onDemandChannels",
    label: "Canais on demand",
    primaryColor: "#4FCBC1",
    secondaryColor: "#085750",
    plusColor: "#4FCBC1",
    content: "Conteúdo da Tab 3",
  },
  {
    id: "individualChannels",
    label: "Canais individuais",
    primaryColor: "#FF8000",
    secondaryColor: "#4B2B0B",
    plusColor: "#FF6C00",
    content: "Conteúdo da Tab 4",
  },
  {
    id: "originals",
    label: "Conteúdos originais do UOL",
    primaryColor: "#486CFF",
    secondaryColor: "#011258",
    plusColor: "#0076FF",
    content: "Conteúdo da Tab 5",
  },
];

const carrossel = {
  sports: [
    {
      title: "Champions League",
      category: "esportes",
      img: "https://imguol.com/p/pp/uol-play/nova-pv/destaques/esportes/01.webp",
    },
    // {
    //   title: "CCONMEBOL Sul-americana",
    //   category: "esportes",
    //   img: "https://imguol.com/p/pp/uol-play/nova-pv/destaques/esportes/02.webp",
    // },
    // {
    //   title: "UFC",
    //   category: "esportes",
    //   img: "https://imguol.com/p/pp/uol-play/nova-pv/destaques/esportes/03.webp",
    // },
    // {
    //   title: "NBA",
    //   category: "esportes",
    //   img: "https://imguol.com/p/pp/uol-play/nova-pv/destaques/esportes/04.webp",
    // },
    // {
    //   title: "F1",
    //   category: "esportes",
    //   img: "https://imguol.com/p/pp/uol-play/nova-pv/destaques/esportes/05.webp",
    // },
    // {
    //   title: "Liga Saudita",
    //   category: "esportes",
    //   img: "https://imguol.com/p/pp/uol-play/nova-pv/destaques/esportes/06.webp",
    // },
  ],
  liveChannels: [
    {
      title: "Trato Feito",
      category: "Ao Vivo",
      img: "https://imguol.com/p/pp/uol-play/nova-pv/destaques/aovivo/01.webp",
    },
    {
      title: "Jogo Aberto",
      category: "Ao Vivo",
      img: "https://imguol.com/p/pp/uol-play/nova-pv/destaques/aovivo/02.webp",
    },
    {
      title: "Em Busca de Alienígenas",
      category: "Ao Vivo",
      img: "https://imguol.com/p/pp/uol-play/nova-pv/destaques/aovivo/03.webp",
    },
    {
      title: "Mentes Criminosas: Evolution",
      category: "Ao Vivo",
      img: "https://imguol.com/p/pp/uol-play/nova-pv/destaques/aovivo/04.webp",
    },
    {
      title: "Shark Tank Brasil",
      category: "Ao Vivo",
      img: "https://imguol.com/p/pp/uol-play/nova-pv/destaques/aovivo/05.webp",
    },
    {
      title: "Friends",
      category: "Ao Vivo",
      img: "https://imguol.com/p/pp/uol-play/nova-pv/destaques/aovivo/06.webp",
    },
  ],
  onDemandChannels: [
    {
      title: "Senhor dos Anéis",
      category: "On Demand",
      img: "https://imguol.com/p/pp/uol-play/nova-pv/destaques/ondemand/01.png",
    },
    {
      title: "Ghosts",
      category: "On Demand",
      img: "https://imguol.com/p/pp/uol-play/nova-pv/destaques/ondemand/02.png",
    },
    {
      title: "Dating Naked",
      category: "On Demand",
      img: "https://imguol.com/p/pp/uol-play/nova-pv/destaques/ondemand/03.png",
    },
    {
      title: "Acende a Luz",
      category: "On Demand",
      img: "https://imguol.com/p/pp/uol-play/nova-pv/destaques/ondemand/04.png",
    },
  ],
  individualChannels: [
    {
      title: "Aeroporto - Área Restrita",
      category: "Individuais",
      img: "https://imguol.com/p/pp/uol-play/nova-pv/destaques/individuais/01.webp",
    },
    {
      title: "Amigos Imaginários",
      category: "Individuais",
      img: "https://imguol.com/p/pp/uol-play/nova-pv/destaques/individuais/02.webp",
    },
    {
      title: "UFC",
      category: "Individuais",
      img: "https://imguol.com/p/pp/uol-play/nova-pv/destaques/individuais/03.webp",
    },
    {
      title: "NBA",
      category: "Individuais",
      img: "https://imguol.com/p/pp/uol-play/nova-pv/destaques/individuais/04.webp",
    },
    {
      title: "Golden Globe",
      category: "Individuais",
      img: "https://imguol.com/p/pp/uol-play/nova-pv/destaques/individuais/05.webp",
    },
    {
      title: "O Casal Da Casa Ao Lado",
      category: "Individuais",
      img: "https://imguol.com/p/pp/uol-play/nova-pv/destaques/individuais/06.png",
    },
  ],
  originals: [
    {
      title: "Acenda a Luz",
      category: "Originais",
      img: "https://imguol.com/p/pp/uol-play/nova-pv/destaques/originais/01.webp",
    },
    {
      title: "Primeiro Cartel da Capital",
      category: "Originais",
      img: "https://imguol.com/p/pp/uol-play/nova-pv/destaques/originais/02.webp",
    },
    {
      title: "O Vampiro de Niterói",
      category: "Originais",
      img: "https://imguol.com/p/pp/uol-play/nova-pv/destaques/originais/03.webp",
    },
    {
      title: "O Palmeiras da Virada",
      category: "Originais",
      img: "https://imguol.com/p/pp/uol-play/nova-pv/destaques/originais/04.webp",
    },
    {
      title: "Romance Nas Estrelas",
      category: "Originais",
      img: "https://imguol.com/p/pp/uol-play/nova-pv/destaques/originais/05.webp",
    },
  ],
};

const destaques = [
  {
    id: "sports",
    prefix: "Esportes",
    title: "O melhor do esporte mundial",
    subtitle:
      "Confira grandes disputas do Paulistão, UFC, UEFA Champions League, CONMEBOL Libertadores e NBA.",
    logos: [
      {
        img: "https://imguol.com.br/p/pp/uol-play/nova-pv/destaques/logos/logo_HBO_MAX.svg",
        link: "https://play.uol.com.br/lp/hbo-max",
      },
      {
        img: "https://imguol.com.br/p/pp/uol-play/nova-pv/destaques/logos/logo_paramount.png",
        link: "https://play.uol.com.br/lp/paramountplus",
      },
      {
        img: "https://imguol.com.br/p/pp/uol-play/nova-pv/destaques/logos/logo_UFC_Fight_Pass.svg",
        link: "https://play.uol.com.br/lp/esportes/ufc",
      },
      {
        img: "https://imguol.com.br/p/pp/uol-play/nova-pv/destaques/logos/logo-nba.svg",
        link: "https://play.uol.com.br/lp/esportes/nba",
      },
      {
        img: "https://imguol.com.br/p/pp/uol-play/nova-pv/destaques/logos/Logo_Paulistao.svg",
        link: "https://play.uol.com.br/lp/esportes/paulistao",
      },
      {
        img: "https://imguol.com.br/p/pp/uol-play/nova-pv/destaques/logos/logo_BandSports.svg",
        link: "https://play.uol.com.br/lp/esportes/band-bandsports",
      },
    ],
  },
  {
    id: "liveChannels",
    prefix: "Canais ao vivo",
    title: "Para assistir ao vivo",
    subtitle:
      "Com UOL Play você tem acesso a uma programação completa para assistir ao vivo. São filmes, séries, programas esportivos e musicais para aproveitar muito.",
    logos: [
      {
        img: "https://imguol.com.br/p/pp/uol-play/nova-pv/destaques/logos/Logo_History.png",
        link: "https://play.uol.com.br/lp/history-channel",
      },
      {
        img: "https://imguol.com.br/p/pp/uol-play/nova-pv/destaques/logos/Logo_BandSports.png",
        link: "https://play.uol.com.br/lp/esportes/band-bandsports",
      },
      {
        img: "https://imguol.com.br/p/pp/uol-play/nova-pv/destaques/logos/Logo_History2.png",
        link: "https://play.uol.com.br/lp/history-channel",
      },
      {
        img: "https://imguol.com.br/p/pp/uol-play/nova-pv/destaques/logos/Logo_AXN.png",
        link: "https://play.uol.com.br/lp/axn",
      },
      {
        img: "https://imguol.com.br/p/pp/uol-play/nova-pv/destaques/logos/Logo_Sony_Channel.png",
        link: "https://play.uol.com.br/lp/sony-channel",
      },
      {
        img: "https://imguol.com.br/p/pp/uol-play/nova-pv/destaques/logos/Logo_Warner.png",
        link: null,
      },
    ],
  },
  {
    id: "onDemandChannels",
    prefix: "Canais on demand",
    title: "Assista quando quiser",
    subtitle:
      "Vários conteúdos prontos para dar o Play. Confira os canais disponíveis e suas programações de destaque.",
    logos: [
      {
        img: "https://imguol.com.br/p/pp/uol-play/nova-pv/destaques/logos/logo_HBO_MAX.svg",
        link: "https://play.uol.com.br/lp/hbo-max",
      },
      {
        img: "https://imguol.com.br/p/pp/uol-play/nova-pv/destaques/logos/logo_paramount.png",
        link: "https://play.uol.com.br/lp/paramountplus",
      },
      {
        img: "https://imguol.com.br/p/pp/uol-play/nova-pv/destaques/logos/Logo_UOL_Originais.png",
        link: "https://play.uol.com.br/lp/uol-play-originais",
      }
    ],
  },
  {
    id: "individualChannels",
    prefix: "Canais individuais",
    title: "Monte como quiser",
    subtitle:
      "No UOL Play, você pode incluir as programações que mais gosta, ou contratar canais individualmente. Confira e aproveite!",
    logos: [
      {
        img: "https://imguol.com.br/p/pp/uol-play/nova-pv/destaques/logos/logo_HBO_MAX.svg",
        link: "https://play.uol.com.br/lp/hbo-max",
      },
      {
        img: "https://imguol.com.br/p/pp/uol-play/nova-pv/destaques/logos/logo_paramount.png",
        link: "https://play.uol.com.br/lp/paramountplus",
      },
      {
        img: "https://imguol.com.br/p/pp/uol-play/nova-pv/destaques/logos/logo_UFC_Fight_Pass.svg",
        link: "https://play.uol.com.br/lp/esportes/ufc",
      },
      {
        img: "https://imguol.com.br/p/pp/uol-play/nova-pv/destaques/logos/logo-nba.svg",
        link: "https://play.uol.com.br/lp/esportes/nba",
      },
      {
        img: "https://imguol.com.br/p/pp/uol-play/nova-pv/destaques/logos/logo_Belas.png",
        link: null,
      },
      {
        img: "https://imguol.com.br/p/pp/uol-play/nova-pv/destaques/logos/Universal+.svg",
        link: "https://play.uol.com.br/lp/universalplus",
      },
    ],
  },
  {
    id: "originals",
    prefix: "Conteúdos originais do UOL",
    title: "Aproveite nossos conteúdos exclusivos:",
    subtitle:
      "Todos planos incluem UOL Originais, com nossos documentários e séries. E Canal UOL, trazendo notícias, gastronomia, moda, entretenimento e muito mais, na voz de grandes jornalistas e apresentadores do país.",
    logos: [
      {
        img: "https://imguol.com.br/p/pp/uol-play/nova-pv/destaques/logos/Logo_UOL_Originais.png",
        link: "https://play.uol.com.br/lp/uol-play-originais",
      },
      {
        img: "https://imguol.com.br/p/pp/uol-play/nova-pv/destaques/logos/logo_canal_uol.svg",
        link: null,
      },
    ],
  },
];

const settings = {
  dots: false,
  arrows: false,
  infinite: true,
  speed: 500,
  autoplay: false,
  autoplaySpeed: 3000,
  slidesToShow: 1,
  slidesToScroll: 1,
  customPaging: () => <div className="slick-custom-dots" />,
};

export default function NewHighlights() {
  const [activeTab, setActiveTab] = useState("sports");
  const [sliderData, setSliderData] = useState(carrossel);

  // useEffect(() => {
  //   async function getSliderData() {
  //     try {
  //       const response = await fetch(
  //         "https://jsuol.com/p/pp/uol-play/publicador/pv/highlights.json"
  //       );
  //       const { carrossel } = await response.json();

  //       setSliderData(carrossel);
  //     } catch (error) {
  //       console.log(error);
  //     }
  //   }

  //   getSliderData();
  // }, []);

  const TabContentComponent = () => {
    const { title, subtitle, logos } = destaques.find(
      (item) => item.id === activeTab
    );

    return (
      <>
        <div className="mobile-title">
          <h2>{title}</h2>
          <p>{subtitle}</p>
        </div>
        <div className="slider-container">
          <Slider {...settings}>
            {sliderData[activeTab]?.map((item) => (
              <div key={item.title} className="poster">
                <img src={item.img} alt={item.title} loading="lazy" />
              </div>
            ))}
          </Slider>
        </div>
        <div className="content">
          <div className="desktop-title">
            <h2>{title}</h2>
            <p>{subtitle}</p>
          </div>
          <div className="logos">
            {logos.map((item, index) => (
              <a
                key={"logos" + index}
                href={item.link}
                target="_blank"
                rel="noopener noreferrer"
              >
                <div key={index} className="logo">
                  <img src={item.img} alt="logo" />
                </div>
              </a>
            ))}
          </div>
        </div>
      </>
    );
  };

  return (
    <Section id="highlights">
      <Wrapper>
        <h2>É só dar o Play!</h2>
        <p>O UOL Play tem filmes, séries, esportes, notícias e muito mais.</p>

        <TabContainer>
          <TabList>
            {tabs.map((tab, index) => (
              <Tab
                key={index}
                $isActive={activeTab === tab.id}
                $primaryColor={tab.primaryColor}
                $secondaryColor={tab.secondaryColor}
                onClick={() => setActiveTab(tab.id)}
              >
                {tab.label}
                <Plus
                  $plusColor={tab.plusColor}
                  $isActive={tab.id === activeTab}
                >
                  <span></span>
                  <span></span>
                </Plus>
              </Tab>
            ))}
          </TabList>
          <TabContent>
            <TabContentComponent />
          </TabContent>
        </TabContainer>
      </Wrapper>
    </Section>
  );
}
